module.exports = __webpack_public_path__ + "static/media/iconfinder_Streamline-18_185038.aed3ec40.svg";